// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","modal":"Modal_modal__DJDMv","slide-down":"Modal_slide-down__iZx4X"};